import {Select, MenuItem, Typography, Box} from '@mui/material';
import {
  monthTextBox,
  selectMonth,
  paymentTextStyles,
  selectMonthRow,
} from './styles';
import React from 'react';

interface ExpandedMonthlyRevenueMonthSelectorProps {
  months: string[];
  selectedMonth: string;
  setSelectedMonth: (month: string) => void;
  isFuture: boolean;
}

const ExpandedMonthlyRevenueMonthSelector: React.FC<
  ExpandedMonthlyRevenueMonthSelectorProps
> = ({months, selectedMonth, setSelectedMonth, isFuture}) => (
  <Box sx={monthTextBox}>
    <Typography variant="body2" sx={paymentTextStyles}>
      {isFuture
        ? 'Estimated total payments for the selected month'
        : 'total payments received in the current month'}
    </Typography>
    <Box sx={selectMonthRow}>
      <Select
        value={selectedMonth}
        onChange={e => setSelectedMonth(e.target.value)}
        size="small"
        sx={selectMonth}
        variant="outlined"
        displayEmpty
      >
        {months.map(month => (
          <MenuItem key={month} value={month}>
            {month}
          </MenuItem>
        ))}
      </Select>
    </Box>
  </Box>
);

export default ExpandedMonthlyRevenueMonthSelector;
